import { render, staticRenderFns } from "./ConfirmAccountForm.vue?vue&type=template&id=b8914b72&scoped=true"
import script from "./ConfirmAccountForm.vue?vue&type=script&lang=ts"
export * from "./ConfirmAccountForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8914b72",
  null
  
)

export default component.exports